import { render, staticRenderFns } from "./DerbyshireNHS.vue?vue&type=template&id=139b7bc4&scoped=true"
import script from "./DerbyshireNHS.vue?vue&type=script&lang=js"
export * from "./DerbyshireNHS.vue?vue&type=script&lang=js"
import style0 from "./DerbyshireNHS.vue?vue&type=style&index=0&id=139b7bc4&prod&scoped=true&lang=css"
import style1 from "./DerbyshireNHS.vue?vue&type=style&index=1&id=139b7bc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139b7bc4",
  null
  
)

export default component.exports